import React, { useEffect, useState } from "react";
import styles from "./manageAdmins.module.css";
import { getAll, postData, deleteData } from "utils/queries";
import Button from "common/Button";
import Toast from "utils";

import DataTable_ from "common/DataTable";

const ManageAdmins = () => {
  const [linkedAdmins, setLinkedAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState("invite"); // invite | otp
  const [inviteEmail, setInviteEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchLinkedAdmins();
  }, []);

  const fetchLinkedAdmins = async () => {
    setLoading(true);
    try {
      const result = await getAll("admin/linked-admins");
      if (result?.data?.success) {
        setLinkedAdmins(result.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching linked admins:", error);
      Toast().Error("Failed to fetch linked admins");
    } finally {
      setLoading(false);
    }
  };

  const handleInvite = async () => {
    if (!inviteEmail) return Toast().Error("Please enter email");
    if (submitting) return;
    setSubmitting(true);
    try {
      const response = await postData("admin/link-invite", { email: inviteEmail });
      if (response?.data?.success) {
        Toast().Success("OTP sent to email");
        setModalStep("otp");
      }
    } catch (error) {
      console.error(error);
      Toast().Error(error?.response?.data?.message || "Failed to send invite");
    } finally {
      setSubmitting(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) return Toast().Error("Please enter OTP");
    if (submitting) return;
    setSubmitting(true);
    try {
      const response = await postData("admin/link-verify", { email: inviteEmail, otp });
      if (response?.data?.success) {
        Toast().Success("Admin linked successfully");
        closeModal();
        fetchLinkedAdmins();
      }
    } catch (error) {
      console.error(error);
      Toast().Error(error?.response?.data?.message || "Verification failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleUnlink = async (adminId) => {
    if(!window.confirm("Are you sure you want to unlink this admin?")) return;

    try {
        const response = await deleteData(`admin/link/${adminId}`);
         if (response?.data?.success) {
          Toast().Success("Unlinked successfully");
          fetchLinkedAdmins();
         }
    } catch(error){
        console.error(error);
        Toast().Error(error?.response?.data?.message || "Unlink failed");
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalStep("invite");
    setInviteEmail("");
    setOtp("");
    setSubmitting(false);
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => `${row.first_name || 'Admin'} ${row.last_name || ''}`,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
        name: "Linked At",
        selector: (row) => new Date(row.linked_at).toLocaleDateString(),
    },
    {
      name: "Action",
      cell: (row) => (
        <button
            onClick={() => handleUnlink(row.id)}
            style={{ color: 'red', background: 'none', border: 'none', cursor: 'pointer' }}
        >
            Unlink
        </button>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Manage Admins</h1>
        <Button label="Link New Admin" onClick={() => setIsModalOpen(true)} />
      </div>

      <div className={styles.tableContainer}>
        <DataTable_
          data={linkedAdmins}
          columns={columns}
          totalCount={linkedAdmins.length}
          handlefetchData={()=>{}}
          hidePagination={true}
        />
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>{modalStep === "invite" ? "Link New Admin" : "Verify OTP"}</h2>

            {modalStep === "invite" ? (
              <>
                <p>Enter the email of the admin you want to link.</p>
                <input
                    type="email"
                    placeholder="Admin Email"
                    value={inviteEmail}
                    onChange={(e) => setInviteEmail(e.target.value)}
                    className={styles.input}
                />
                <div className={styles.modalActions}>
                  <Button label="Cancel" onClick={closeModal} style={{background:'#ccc'}} />
                  <Button label={submitting ? "Sending..." : "Send OTP"} onClick={handleInvite} disabled={submitting} />
                </div>
              </>
            ) : (
              <>
                 <p>Enter the OTP sent to {inviteEmail}</p>
                 <input
                    type="text"
                    placeholder="OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className={styles.input}
                />
                <div className={styles.modalActions}>
                  <Button label="Cancel" onClick={closeModal} style={{background:'#ccc'}} />
                  <Button label={submitting ? "Verifying..." : "Verify"} onClick={handleVerifyOtp} disabled={submitting} />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageAdmins;
